import { Directive, effect, inject, input } from '@angular/core';
import { CmdkService } from './cmdk.service';
import { QpxCmdkCommand } from './command';
import type { CmdkInputUpdateOn } from './models';

@Directive({
    selector: 'input[qpxCmdkInput]',
    host: {
        class: 'qpx-cmdk-input',
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-expanded': 'true',
        '[attr.aria-controls]': 'command.controlledListIds()',
        '[attr.aria-activedescendant]': 'command.activeItemId()',
        '(blur)': 'onInput($event, "blur")',
        '(change)': 'onInput($event, "change")',
        '(input)': 'onInput($event, "input")',
    },
})
export class QpxCmdkInput {
    //#region Dependency injection
    private readonly cmdkService = inject(CmdkService);
    protected readonly command = inject(QpxCmdkCommand);
    //#endregion

    //#region Inputs
    public readonly updateOn = input<CmdkInputUpdateOn>('input');
    public readonly value = input('');
    //#endregion

    //#region Lifecycle hooks
    constructor() {
        effect(() => this.search(this.value()));
    }
    //#endregion

    //#region Template methods
    protected onInput(e: Event, source: CmdkInputUpdateOn): void {
        if (
            this.updateOn() !== source ||
            !(e.target instanceof HTMLInputElement)
        )
            return;

        this.search(e.target.value);
    }
    //#endregion

    //#region Public methods
    public search(value: string): void {
        this.cmdkService.setSearch(value);
    }
    //#endregion
}
